import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { ReservedSpace, WalletTrackerAlertIcon } from '@root/shared/ui-kit'

import { unseenAlertsCountAtom } from '../../atoms/reatom-tracking-wallets-alerts-table'

import { WalletAlertsDialog } from './wallet-alerts-dialog'

import type { ClassNameProps } from '@root/shared/react'

type WalletAlertsButtonProps = {} & ClassNameProps

export const WalletAlertsButton: React.FC<WalletAlertsButtonProps> = ({
  className,
}) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [counter] = useAtom(unseenAlertsCountAtom)

  const handleOpenChange = (open: boolean) => {
    setOpen(open)
  }

  const renderCounter = () => {
    const counter_ = counter >= 100 ? '99+' : counter.toString()
    return (
      <SquareCounter aria-disabled={counter === 0} aria-expanded={open}>
        <ReservedSpace $chars={counter_.length}>{counter_}</ReservedSpace>
      </SquareCounter>
    )
  }

  return (
    <WalletAlertsDialog open={open} onOpenChange={handleOpenChange}>
      <Root
        type="button"
        className={className}
        aria-disabled={!counter}
        aria-expanded={open}
      >
        <WalletTrackerAlertIcon size={12} />
        {t('wallet-tracker')}
        {renderCounter()}
      </Root>
    </WalletAlertsDialog>
  )
}

const Root = styled.button`
  all: unset;
  display: grid;
  height: 16px;
  text-transform: capitalize;
  padding-inline: 3px;
  padding-inline-end: 2px;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;
  white-space: nowrap;

  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  cursor: pointer;

  border-radius: 4px;
  border: 1px solid var(--amberA-2);
  transition: all 0.15s linear;

  background: var(--amberA-2);
  color: var(--amber-9);

  &:not([aria-disabled='true']):hover {
    border-color: var(--amberA-3);
  }

  &[aria-expanded='true'] {
    opacity: 0.8;
  }
`
const SquareCounter = styled.span`
  background: var(--amberA-3);
  color: var(--amberA-8);

  &[aria-disabled='false'] {
    background: var(--amber-9);
    color: var(--appearance-1);
  }

  font-weight: 700;
  line-height: 16px;
  border-radius: 2px;
  font-size: 8px;
  line-height: 1;
  padding: 2px;
  height: 12px;
  min-width: 12px;

  display: grid;
  place-items: center;
  transition: all 0.15s linear;
`
